'use client'
import { createContext, useEffect, useState } from 'react'
import type { Dispatch, FC, ReactNode, SetStateAction } from 'react'
import { usePathname } from 'next/navigation'

export type TypePageDesignContext = {
  pageHasHeaderBgImage: boolean
  setPageHasHeaderBgImage: Dispatch<SetStateAction<TypePageDesignContext['pageHasHeaderBgImage']>>
  headerTextColor: 'dark' | 'light'
  setHeaderTextColor: Dispatch<SetStateAction<TypePageDesignContext['headerTextColor']>>
}

export const PageDesignContext = createContext<TypePageDesignContext | null>(null)

interface Props {
  children: ReactNode
}

export const PageDesignProvider:FC<Props> = ({ children }) => {
  const [pageHasHeaderBgImage, setPageHasHeaderBgImage] = useState<TypePageDesignContext['pageHasHeaderBgImage']>(true)
  const [headerTextColor, setHeaderTextColor] = useState<TypePageDesignContext['headerTextColor']>('light')
  const pathname = usePathname()

  useEffect(() => {
    // setPageHasHeaderBgImage(pathname?.includes('/products/') || pathname?.includes('/projects/') || pathname?.includes('/collection/'))
  }, [pathname])

  return (
    <PageDesignContext.Provider value={{
      pageHasHeaderBgImage,
      setPageHasHeaderBgImage,
      headerTextColor,
      setHeaderTextColor
    }}>
      {children}
    </PageDesignContext.Provider>
  )
}
